import { ClientRequestForm } from '@/components/ClientRequestForm';
import { useSubmitReactivation } from '@/api/hooks';

export function ReactivationRequest() {
  const submit = useSubmitReactivation();
  return (
    <ClientRequestForm
      title="Client Reactivation Request"
      description="Select one or more clients to reactivate and the effective date. The list includes existing and terminated clients. On submit, you receive a receipt and the admin team is notified. The client record is updated in Maconomy separately."
      scope="all"
      dateLabel="Effective Reactivation Date"
      submit={submit}
    />
  );
}
